import React from "react";
import Header from "../Components/Header/Header";
import CartSection from "../Components/CartSection/CartSection";
import Subscribe from "../Components/Subscribe/Subscribe";
import Footer from "../Components/Footer/Footer";

function Cart() {
  return (
    <div>
      <Header />
      <CartSection />
      <Subscribe />
      <Footer />
    </div>
  );
}

export default Cart;
